import type {
  NotificationCountParams,
  NotificationListParams,
} from "../types";

export const notificationKeys = {
  all: ["notifications"] as const,
  counts: (params: NotificationCountParams) =>
    [...notificationKeys.all, "counts", params] as const,
  list: (params: NotificationListParams) =>
    [...notificationKeys.all, "list", params] as const,
} as const;
